import Container from '@ui/container/container';

const AudiencesSkeletonLoader = () => {
  const NUMBER_ROWS = 3;

  return (
    <Container className="flex fd-column">
      <Container height="calc(100vh - 200px)" style={{ position: 'relative', overflowY: 'hidden' }}>
        <Container
          height="76px"
          width="1006px"
          className="margin-b-24"
          skLoader={{
            height: 76,
            width: 1006,
            radius: 16,
            loading: true,
            design: 'GlobalCont1',
          }}
        />
        {Array.from({ length: NUMBER_ROWS }).map((_, i) => (
          <Container key={i} className="flex fd-row gap-24 margin-b-16">
            <Container
              height="180px"
              width="320px"
              skLoader={{
                height: 180,
                width: 320,
                radius: 16,
                loading: true,
                design: 'GlobalCont1',
              }}
            />
            <Container
              height="180px"
              width="320px"
              skLoader={{
                height: 180,
                width: 320,
                radius: 16,
                loading: true,
                design: 'GlobalCont1',
              }}
            />
            <Container
              height="180px"
              width="320px"
              skLoader={{
                height: 180,
                width: 320,
                radius: 16,
                loading: true,
                design: 'GlobalCont1',
              }}
            />
          </Container>
        ))}
      </Container>
    </Container>
  );
};

export default AudiencesSkeletonLoader;
